import apiClient from '../configServices'
import NProgress from 'nprogress'

apiClient.interceptors.request.use(config => {
    NProgress.start()
    return config
})
apiClient.interceptors.response.use(response => {
    NProgress.done(true)
    return response
})

export default {
    getAbilitiesReports(id) {
        return apiClient.get('/player/' + id + '/abilityReport')
    },
    getFilteredReport(item) {
        if (item.ability_id && item.period_id) {
            return apiClient.get('/player/' + item.player_id + "/abilityReport" + "?ability_id=" + item.ability_id
                + "&period_id=" + item.period_id)
        }
        else {
            if (item.ability_id) {
                return apiClient.get('/player/' + item.player_id + "/abilityReport" + "?ability_id=" + item.ability_id)
            } else {
                if (item.period_id) {
                    return apiClient.get('/player/' + item.player_id + "/abilityReport" + "?period_id=" + item.period_id)
                }
                else {
                    return apiClient.get('/player/' + item.player_id + '/abilityReport')
                }
            }
        }
    }
}